import { Injectable } from "@angular/core";
import { Subject } from "rxjs";


@Injectable()
export class VehiclePlanningService {

    GeneratePlanningClick: Subject<boolean>;

    constructor() {
        this.GeneratePlanningClick = new Subject();
    }

    isGeneratePlanClick(click: boolean) {
        this.GeneratePlanningClick.next(click);
    }

}